import { ViewTypes } from "modules/Types";
import isEqual from "lodash/isEqual";
const { MOBILE } = ViewTypes;

export const getRandomSubjectLine = (brandName: string = 'me') => {
    /** Subject line templates with emojis and brand placeholder */
    const SUBJECT_LINE_TEMPLATES = [
        '👋 Hey it\'s {brandName}!',
        '✨ Big news from {brandName}!',
        '🎉 Special update from {brandName}',
        '💌 A message just for you from {brandName}',
        '🌟 Exciting updates from {brandName}!',
        '📢 Important announcement from {brandName}',
        '�� Guess what? {brandName} have news!',
        '🎯 Don\'t miss this update from {brandName}!',
        '🔥 Hot news from {brandName}!',
        '💝 A special note from {brandName}'
    ]
    const randomTemplate = SUBJECT_LINE_TEMPLATES[Math.floor(Math.random() * SUBJECT_LINE_TEMPLATES.length)]
    return randomTemplate.replace('{brandName}', brandName)
}

export const getInitialRawEmailTemplate = (args: {
    brandName?: string | null;
    brandImage?: string | null;
    preview?: ViewTypes;
}) => {
    const { brandImage, brandName, preview } = args;
    const width = isEqual(preview, MOBILE) ? "70%" : "90%";

    return `
  <div>
    <p>Hey this is ${brandName}, I wanted to tell you about...</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p style="display: flex; align-items: center;"><img style="vertical-align: middle; border-radius: 6px;" src=${brandImage} alt="" width="34" height="34">&nbsp;<strong style="width: 90%;">${brandName}</strong></p>
  </div>
`;
};

export const BLANK_CANVAS = `<div style="word-wrap: break-word; background-color: #ffff; padding: 32px 24px; border: 1px solid #C8C7CC; border-radius: 6px; width: 90%; margin: 0px auto;">
<p>&nbsp;</p>
</div>`;
